import React, { useState } from "react";
import "../pagina-modelo/pagina-modelo.css";
import InstaModal from '../../components/insta-modal/insta-modal.jsx';

const mockData = [


];

const statusConfig = {
  "Em dia": { badge: "success", icon: "bi-check-circle-fill" },
  "Atenção": { badge: "warning", icon: "bi-exclamation-circle-fill" },
  Irregular: { badge: "danger", icon: "bi-x-circle-fill" },
};

const metasMensais = {
  reels: 8,
  postagens: 20,
  stories: 60,
  visualizacoes: 10000,
};

function ProgressMeta({ label, valor, meta, icon }) {
  const pct = Math.min(Math.round((valor / meta) * 100), 100);
  const cor = pct >= 100 ? "success" : pct >= 60 ? "warning" : "danger";
  return (
    <div className="fi-meta-item mb-2">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <span className="fi-meta-label">
          <i className={`bi ${icon} me-1`}></i>
          {label}
        </span>
        <span className={`fi-meta-val text-${cor}`}>
          {valor.toLocaleString()} / {meta.toLocaleString()}
        </span>
      </div>
      <div className="progress fi-progress">
        <div
          className={`progress-bar bg-${cor}`}
          role="progressbar"
          style={{ width: `${pct}%` }}
          aria-valuenow={pct}
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  );
}

function StatChip({ icon, label, value, color = "primary" }) {
  return (
    <div className={`fi-stat-chip fi-stat-chip--${color}`}>
      <i className={`bi ${icon} fi-stat-icon`}></i>
      <div>
        <div className="fi-stat-value">{value.toLocaleString()}</div>
        <div className="fi-stat-label">{label}</div>
      </div>
    </div>
  );
}

function FranquiaCard({ f, onEdit }) {
  const st = statusConfig[f.status];
  return (
    <div className="col-12 col-lg-6 col-xxl-4">
      <div className="fi-card h-100">
        {/* Header */}
        <div className="fi-card-header">
          <div className="fi-avatar">
            <i className="bi bi-instagram"></i>
          </div>
          <div className="fi-card-info">
            <h6 className="fi-card-name">{f.nome}</h6>
            <span className="fi-card-perfil">{f.perfil}</span>
            <span className="fi-card-cidade">
              <i className="bi bi-geo-alt me-1"></i>
              {f.cidade}
            </span>
          </div>
          <div className="ms-auto d-flex flex-column align-items-end gap-1">
            <span className={`badge bg-${st.badge} fi-badge`}>
              <i className={`bi ${st.icon} me-1`}></i>
              {f.status}
            </span>
            <button
              className="btn btn-sm fi-btn-edit"
              onClick={() => onEdit(f)}
              title="Editar"
            >
              <i className="bi bi-pencil-square"></i>
            </button>
          </div>
        </div>

        {/* Contagem de seguidores */}
        <div className="fi-followers-row">
          <div className="fi-followers-item">
            <span className="fi-followers-num">
              {f.seguidores.toLocaleString()}
            </span>
            <span className="fi-followers-lbl">Seguidores</span>
          </div>
          <div className="fi-followers-divider"></div>
          <div className="fi-followers-item">
            <span className="fi-followers-num">
              {f.seguindo.toLocaleString()}
            </span>
            <span className="fi-followers-lbl">Seguindo</span>
          </div>
          <div className="fi-followers-divider"></div>
          <div className="fi-followers-item">
            <span className={`fi-followers-num fi-new-seg`}>
              +{f.novosSeguidores}
            </span>
            <span className="fi-followers-lbl">Novos / mês</span>
          </div>
        </div>

        {/* Stats chips */}
        <div className="fi-stats-grid">
          <StatChip
            icon="bi-play-circle-fill"
            label="Reels"
            value={f.reels}
            color="purple"
          />
          <StatChip
            icon="bi-grid-3x3-gap-fill"
            label="Postagens"
            value={f.postagens}
            color="blue"
          />
          <StatChip
            icon="bi-camera-reels-fill"
            label="Stories"
            value={f.stories}
            color="orange"
          />
          <StatChip
            icon="bi-eye-fill"
            label="Visualizações"
            value={f.visualizacoes}
            color="teal"
          />
          <StatChip
            icon="bi-heart-fill"
            label="Curtidas"
            value={f.curtidas}
            color="red"
          />
          <StatChip
            icon="bi-chat-dots-fill"
            label="Comentários"
            value={f.comentarios}
            color="green"
          />
          <StatChip
            icon="bi-share-fill"
            label="Compartilhados"
            value={f.compartilhamentos}
            color="indigo"
          />
          <StatChip
            icon="bi-bookmark-fill"
            label="Salvamentos"
            value={f.salvamentos}
            color="yellow"
          />
        </div>

        {/* Metas mensais */}
        <div className="fi-metas">
          <div className="fi-metas-title">
            <i className="bi bi-flag-fill me-1"></i> Metas do mês
          </div>
          <ProgressMeta
            label="Reels"
            valor={f.reels}
            meta={metasMensais.reels}
            icon="bi-play-circle"
          />
          <ProgressMeta
            label="Postagens"
            valor={f.postagens}
            meta={metasMensais.postagens}
            icon="bi-grid-3x3-gap"
          />
          <ProgressMeta
            label="Stories"
            valor={f.stories}
            meta={metasMensais.stories}
            icon="bi-camera-reels"
          />
          <ProgressMeta
            label="Visualizações"
            valor={f.visualizacoes}
            meta={metasMensais.visualizacoes}
            icon="bi-eye"
          />
        </div>

        {/* Alcance */}
        <div className="fi-alcance">
          <i className="bi bi-broadcast me-1"></i>
          Alcance orgânico:{" "}
          <strong>{f.alcance.toLocaleString()} pessoas</strong>
        </div>
      </div>
    </div>
  );
}

// Modal de cadastro/edição
function FranquiaModal({ show, onClose, onSave, editing }) {
  const empty = {
    nome: "",
    cidade: "",
    perfil: "",
    seguidores: "",
    seguindo: "",
    reels: "",
    postagens: "",
    stories: "",
    visualizacoes: "",
    curtidas: "",
    comentarios: "",
    compartilhamentos: "",
    salvamentos: "",
    alcance: "",
    novosSeguidores: "",
    status: "Em dia",
  };
  const [form, setForm] = useState(editing || empty);

  React.useEffect(() => {
    setForm(editing || empty);
  }, [editing, show]);

  const handle = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  if (!show) return null;

  return (
    <div className="fi-modal-backdrop" onClick={onClose}>
      <div
        className="fi-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="fi-modal-header">
          <h5 className="fi-modal-title">
            <i className="bi bi-instagram me-2"></i>
            {editing ? "Editar Franquia" : "Nova Franquia"}
          </h5>
          <button className="fi-modal-close" onClick={onClose}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div className="fi-modal-body">
          <div className="row g-3">
            {/* Identificação */}
            <div className="col-12">
              <p className="fi-section-label">Identificação</p>
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label fi-label">Nome da Franquia</label>
              <input
                className="form-control fi-input"
                name="nome"
                value={form.nome}
                onChange={handle}
                placeholder="Ex: Franquia Centro"
              />
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label fi-label">Cidade</label>
              <input
                className="form-control fi-input"
                name="cidade"
                value={form.cidade}
                onChange={handle}
                placeholder="Ex: São Paulo"
              />
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label fi-label">Perfil Instagram</label>
              <div className="input-group">
                <span className="input-group-text fi-input-addon">@</span>
                <input
                  className="form-control fi-input"
                  name="perfil"
                  value={form.perfil.replace("@", "")}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, perfil: "@" + e.target.value }))
                  }
                  placeholder="usuario"
                />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label fi-label">Status</label>
              <select
                className="form-select fi-input"
                name="status"
                value={form.status}
                onChange={handle}
              >
                <option value="Em dia">Em dia</option>
                <option value="Atenção">Atenção</option>
                <option value="Irregular">Irregular</option>
              </select>
            </div>

            {/* Audiência */}
            <div className="col-12 mt-1">
              <p className="fi-section-label">Audiência</p>
            </div>
            {[
              ["seguidores", "Seguidores", "bi-people"],
              ["seguindo", "Seguindo", "bi-person-plus"],
              ["novosSeguidores", "Novos Seguidores (mês)", "bi-person-check"],
              ["alcance", "Alcance Orgânico", "bi-broadcast"],
            ].map(([name, label, icon]) => (
              <div className="col-6 col-md-3" key={name}>
                <label className="form-label fi-label">
                  <i className={`bi ${icon} me-1`}></i>
                  {label}
                </label>
                <input
                  type="number"
                  className="form-control fi-input"
                  name={name}
                  value={form[name]}
                  onChange={handle}
                  placeholder="0"
                  min="0"
                />
              </div>
            ))}

            {/* Conteúdo */}
            <div className="col-12 mt-1">
              <p className="fi-section-label">Conteúdo publicado (mês)</p>
            </div>
            {[
              ["reels", "Reels", "bi-play-circle"],
              ["postagens", "Postagens", "bi-grid-3x3-gap"],
              ["stories", "Stories", "bi-camera-reels"],
            ].map(([name, label, icon]) => (
              <div className="col-6 col-md-4" key={name}>
                <label className="form-label fi-label">
                  <i className={`bi ${icon} me-1`}></i>
                  {label}
                </label>
                <input
                  type="number"
                  className="form-control fi-input"
                  name={name}
                  value={form[name]}
                  onChange={handle}
                  placeholder="0"
                  min="0"
                />
              </div>
            ))}

            {/* Engajamento */}
            <div className="col-12 mt-1">
              <p className="fi-section-label">Engajamento</p>
            </div>
            {[
              ["visualizacoes", "Visualizações", "bi-eye"],
              ["curtidas", "Curtidas", "bi-heart"],
              ["comentarios", "Comentários", "bi-chat-dots"],
              ["compartilhamentos", "Compartilhamentos", "bi-share"],
              ["salvamentos", "Salvamentos", "bi-bookmark"],
            ].map(([name, label, icon]) => (
              <div className="col-6 col-md-4" key={name}>
                <label className="form-label fi-label">
                  <i className={`bi ${icon} me-1`}></i>
                  {label}
                </label>
                <input
                  type="number"
                  className="form-control fi-input"
                  name={name}
                  value={form[name]}
                  onChange={handle}
                  placeholder="0"
                  min="0"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="fi-modal-footer">
          <button className="btn fi-btn-cancel" onClick={onClose}>
            Cancelar
          </button>
          <button
            className="btn fi-btn-save"
            onClick={() => onSave(form)}
          >
            <i className="bi bi-check-lg me-1"></i>
            {editing ? "Salvar alterações" : "Cadastrar"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function PaginaModelo() {
  const [franquias, setFranquias] = useState(mockData);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [busca, setBusca] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("Todos");

  const handleSave = (form) => {
    const parsed = {
      ...form,
      seguidores: Number(form.seguidores) || 0,
      seguindo: Number(form.seguindo) || 0,
      reels: Number(form.reels) || 0,
      postagens: Number(form.postagens) || 0,
      stories: Number(form.stories) || 0,
      visualizacoes: Number(form.visualizacoes) || 0,
      curtidas: Number(form.curtidas) || 0,
      comentarios: Number(form.comentarios) || 0,
      compartilhamentos: Number(form.compartilhamentos) || 0,
      salvamentos: Number(form.salvamentos) || 0,
      alcance: Number(form.alcance) || 0,
      novosSeguidores: Number(form.novosSeguidores) || 0,
    };

    if (editing) {
      setFranquias((prev) =>
        prev.map((f) => (f.id === editing.id ? { ...parsed, id: f.id } : f))
      );
    } else {
      setFranquias((prev) => [
        ...prev,
        { ...parsed, id: Date.now() },
      ]);
    }
    setShowModal(false);
    setEditing(null);
  };

  const lista = franquias.filter((f) => {
    const matchBusca =
      f.nome.toLowerCase().includes(busca.toLowerCase()) ||
      f.perfil.toLowerCase().includes(busca.toLowerCase()) ||
      f.cidade.toLowerCase().includes(busca.toLowerCase());
    const matchStatus =
      filtroStatus === "Todos" || f.status === filtroStatus;
    return matchBusca && matchStatus;
  });

  // Totalizadores
  const totais = franquias.reduce(
    (acc, f) => ({
      seguidores: acc.seguidores + f.seguidores,
      reels: acc.reels + f.reels,
      postagens: acc.postagens + f.postagens,
      visualizacoes: acc.visualizacoes + f.visualizacoes,
    }),
    { seguidores: 0, reels: 0, postagens: 0, visualizacoes: 0 }
  );

  return (
    <div className="fi-root">
      {/* Page Header */}

      <InstaModal
        show={showModal}
        nomeFranquia="Casa Ludica Gramado"
        onSave={(dados) => {
          console.log("Recebido no pai:", dados);
          // futuramente: await api.post('/instagram', dados)
        }}
        onClose={() => setShowModal(false)}
      />
      <div className="fi-page-header">
        <div className="fi-page-header-left">
          <div className="fi-logo-wrap">
            <i className="bi bi-instagram fi-logo-icon"></i>
          </div>
          <div>
            <h1 className="fi-page-title">Monitor Instagram</h1>
            <p className="fi-page-sub">
              Acompanhamento das franquias — {franquias.length} unidades
            </p>
          </div>
        </div>
        <button
          className="btn fi-btn-new"
          onClick={() => setShowModal(true)}
        >
          Cadastrar Instagram
        </button>
        <button
          className="btn fi-btn-new"
          onClick={() => {
            setEditing(null);
            setShowModal(true);
          }}
        >
          <i className="bi bi-plus-lg me-2"></i>
          Nova Franquia
        </button>
      </div>

      {/* Totalizadores */}
      <div className="fi-totals">
        {[
          {
            icon: "bi-people-fill",
            label: "Total Seguidores",
            value: totais.seguidores.toLocaleString(),
            color: "blue",
          },
          {
            icon: "bi-play-circle-fill",
            label: "Reels no mês",
            value: totais.reels,
            color: "purple",
          },
          {
            icon: "bi-grid-3x3-gap-fill",
            label: "Postagens no mês",
            value: totais.postagens,
            color: "teal",
          },
          {
            icon: "bi-eye-fill",
            label: "Visualizações",
            value: totais.visualizacoes.toLocaleString(),
            color: "orange",
          },
        ].map((t) => (
          <div className={`fi-total-card fi-total-card--${t.color}`} key={t.label}>
            <i className={`bi ${t.icon} fi-total-icon`}></i>
            <div>
              <div className="fi-total-value">{t.value}</div>
              <div className="fi-total-label">{t.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div className="fi-filters">
        <div className="fi-search-wrap">
          <i className="bi bi-search fi-search-icon"></i>
          <input
            type="text"
            className="form-control fi-search"
            placeholder="Buscar franquia, cidade ou perfil..."
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
          />
        </div>
        <div className="fi-filter-btns">
          {["Todos", "Em dia", "Atenção", "Irregular"].map((s) => (
            <button
              key={s}
              className={`btn fi-filter-btn ${filtroStatus === s ? "fi-filter-btn--active" : ""}`}
              onClick={() => setFiltroStatus(s)}
            >
              {s}
            </button>
          ))}
        </div>
      </div>

      {/* Grid de cards */}
      {lista.length === 0 ? (
        <div className="fi-empty">
          <i className="bi bi-search fi-empty-icon"></i>
          <p>Nenhuma franquia encontrada.</p>
        </div>
      ) : (
        <div className="row g-4">
          {lista.map((f) => (
            <FranquiaCard
              key={f.id}
              f={f}
              onEdit={(f) => {
                setEditing(f);
                setShowModal(true);
              }}
            />
          ))}
        </div>
      )}

      <FranquiaModal
        show={showModal}
        onClose={() => {
          setShowModal(false);
          setEditing(null);
        }}
        onSave={handleSave}
        editing={editing}
      />
    </div>
  );
}